import { useTranslation } from 'react-i18next'
import Segmented from '@ui/elements/Segmented'
import { SegmentedOption } from '@ui/elements/Segmented/types'

import { OrderStatusGroup, OrderStatusGroups as group } from '@ca/common/types'

interface Props {
  selected: OrderStatusGroup
  setSelected: (group: OrderStatusGroup) => void
}

const displayGroups: OrderStatusGroup[] = [
  group.all,
  group.draft,
  group.attention,
  // group.ongoing - splitted into attention and active
  group.active,
  group.completed,
  // group.cancelled - not shown to the customer
]

export default function StatusGroups({ selected, setSelected }: Props) {
  const { t } = useTranslation(['common', 'ui', 'order'])
  const text = 'order:order'

  const options: SegmentedOption<OrderStatusGroup>[] = displayGroups.map(
    (group) => ({
      id: group,
      label: t(`${text}.status.groups.${group}`),
    })
  )

  const value = options.find((option) => option.id === selected)

  return (
    <Segmented
      options={options}
      value={value}
      onChange={(option) => setSelected(option.id)}
    />
  )
}
